import { useEffect, useState } from "react";
import { FunnelX } from "lucide-react";

const FILTER_KEYS = {
  practical: "practical",
  material: "material",
  access: "access",
  report: "report",
  code: "code",
  reviewStatus: "reviewStatus",
};

export default function Filter({ practicals, setPracticalsFiltered }) {
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [filterValues, setFilterValues] = useState([]);
  const [selectedFilterValue, setSelectedFilterValue] = useState(null);

  const availableFilters = [
    { key: FILTER_KEYS.practical, value: "Практика" },
    { key: FILTER_KEYS.material, value: "Методичка" },
    { key: FILTER_KEYS.access, value: "Доступ" },
    { key: FILTER_KEYS.report, value: "Отчёт" },
    { key: FILTER_KEYS.code, value: "Исходный код" },
    { key: FILTER_KEYS.reviewStatus, value: "Статус проверки" },
  ];

  const resetSelectedFilter = () => setSelectedFilter(null);

  useEffect(() => {
    setPracticalsFiltered(practicals);
    resetSelectedFilter();
  }, [practicals]);

  useEffect(() => {
    switch (selectedFilter?.key) {
      case FILTER_KEYS.practical:
        {
          const uniquePracticals = [
            ...new Set(practicals.map((s) => s.number ?? 0)),
          ];
          const res = uniquePracticals.map((elem) => ({
            key: elem,
            value: `Практика ${elem}`,
          }));
          setFilterValues(res);
        }
        break;
      case FILTER_KEYS.material:
        {
          const res = [
            {
              key: true,
              value: "размещена",
            },
            {
              key: false,
              value: "не размещена",
            },
          ];
          setFilterValues(res);
        }
        break;
      case FILTER_KEYS.access:
        {
          const map = new Map();
          practicals.forEach((s) => {
            if (!map.has(s.access)) {
              map.set(s.access, s.accessLabel);
            }
          });
          const res = Array.from(map).map((elem) => ({
            key: elem[0],
            value: elem[1],
          }));
          setFilterValues(res);
        }
        break;
      case FILTER_KEYS.report:
      case FILTER_KEYS.code:
        {
          const res = [
            {
              key: true,
              value: "размещён",
            },
            {
              key: false,
              value: "не размещён",
            },
          ];
          setFilterValues(res);
        }
        break;
      case FILTER_KEYS.reviewStatus:
        {
          const map = new Map();
          practicals.forEach((s) => {
            if (!map.has(s.reviewStatus.code)) {
              map.set(s.reviewStatus.code, s.reviewStatus.name);
            }
          });
          const res = Array.from(map).map((elem) => ({
            key: elem[0],
            value: elem[1],
          }));
          setFilterValues(res);
        }
        break;
      default:
        setFilterValues([]);
    }
    setSelectedFilterValue(null);
  }, [selectedFilter]);

  useEffect(() => {
    if (!selectedFilterValue) {
      setPracticalsFiltered(practicals);
      return;
    }

    switch (selectedFilter?.key) {
      case FILTER_KEYS.practical:
        {
          const res = practicals.filter(
            (elem) => elem.number === selectedFilterValue.key,
          );
          setPracticalsFiltered(res);
        }
        break;
      case FILTER_KEYS.material:
        {
          const func = selectedFilterValue.key
            ? (elem) => elem.materialLink
            : (elem) => !elem.materialLink;
          const res = practicals.filter(func);
          setPracticalsFiltered(res);
        }
        break;
      case FILTER_KEYS.access:
        {
          const res = practicals.filter(
            (elem) => elem.access === selectedFilterValue.key,
          );
          setPracticalsFiltered(res);
        }
        break;
      case FILTER_KEYS.report:
        {
          const func = selectedFilterValue.key
            ? (elem) => elem.reportLink
            : (elem) => !elem.reportLink;
          const res = practicals.filter(func);
          setPracticalsFiltered(res);
        }
        break;
      case FILTER_KEYS.code:
        {
          const func = selectedFilterValue.key
            ? (elem) => elem.codeLink
            : (elem) => !elem.codeLink;
          const res = practicals.filter(func);
          setPracticalsFiltered(res);
        }
        break;
      case FILTER_KEYS.reviewStatus:
        {
          const res = practicals.filter(
            (elem) => elem.reviewStatus.code === selectedFilterValue.key,
          );
          setPracticalsFiltered(res);
        }
        break;
    }
  }, [selectedFilterValue]);

  return (
    <fieldset>
      <legend className="muted">Фильтрация</legend>
      <div className="filters">
        <select
          value={selectedFilter?.value ?? ""}
          onChange={(e) => {
            const value = e.target.value;
            const selectedKey =
              availableFilters.find((elem) => elem.value === value)?.key ?? "";
            setSelectedFilter({ key: selectedKey, value });
          }}
        >
          <option value="">Выберите столбец</option>
          {availableFilters.map((f) => (
            <option key={f.key} value={f.value}>
              {f.value}
            </option>
          ))}
        </select>
        <select
          value={selectedFilterValue?.value ?? ""}
          disabled={!selectedFilter}
          onChange={(e) => {
            let newSelectedValue = null;
            const value = e.target.value;

            if (value !== "") {
              const selectedKey = filterValues.find(
                (elem) => elem.value === e.target.value,
              )?.key;
              newSelectedValue = { key: selectedKey, value };
            }
            setSelectedFilterValue(newSelectedValue);
          }}
        >
          <option value="">Выберите значение</option>
          {filterValues.map((f) => (
            <option key={f.key} value={f.value}>
              {f.value}
            </option>
          ))}
        </select>
        <button
          className="btn small"
          disabled={!selectedFilter}
          title="Сбросить фильтр"
          onClick={resetSelectedFilter}
        >
          <FunnelX size={20} />
        </button>
      </div>
    </fieldset>
  );
}
